// DS: i3.1
// from Vlada
import React from 'react';
import IconWrap from '../IconWrap';
const CloseSmall = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "0",
        height: "0",
        viewBox: "0 0 18 18"
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "currentColor",
        strokeWidth: "2"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1 17L17 1 1 17zM17 17L1 1l16 16z"
    }))));
CloseSmall.displayName = 'CloseSmall';
export default CloseSmall;

//# sourceMappingURL=CloseSmall.js.map